import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CImg,
  CBadge,
  CLink,
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody
} from '@coreui/react'
import { SET_ASIDE_SHOW, SET_VIEW_ADJUST } from '../redux/actions'
import { useQuery } from '@apollo/client';
import {  GET_NEARBY_POLL_MAPS_SAME_YEAR,
          GET_NEARBY_POLL_MAPS_HISTORY,
       } from '../apollo/queries' 

import { 
  SET_POLL_MAP, 
  SET_SEARCH_RESULTS, 
  SET_FEDERAL_POLL_MAP,
  SET_MAP_SELECTED, 
  SET_MAP_COUNT, 
  SET_POLL_MAP_YEAR, 
  SET_POLL_MAP_LOCAL_DIVISION 
} from '../redux/actions'

import { provinceShortToLong } from '../helpers/Utils'

const NearbyMaps = (props) => {
  const show = useSelector(state => state.starter.asideShow)
  const mapCount = useSelector(state => state.starter.mapCount)
  const dispatch = useDispatch()
  const setState = (state) => dispatch({type: SET_ASIDE_SHOW, asideShow: state})
 
  const [nearbyPollMapsSameYear, setNearbyPollMapsSameYear] = useState(null)
  const [nearbyPollMapsHistory, setNearbyPollMapsHistory] = useState(null)

  var majj = props.majj
  var minj = props.minj
  var et = props.et
  
  const { loading1, error1, data1 } = useQuery(
    GET_NEARBY_POLL_MAPS_SAME_YEAR, {
      onCompleted: setNearbyPollMapsSameYear,
      variables: { 
        event_type:et,
        major_jurisdiction:majj,
        minor_jurisdiction:minj,
        local_division:String(props.ld), 
        year:String(props.year), 
        lng:props.lng, 
        lat:props.lat 
      }
  });

  const { loading2, error2, data2 } = useQuery(
    GET_NEARBY_POLL_MAPS_HISTORY, {
      onCompleted: setNearbyPollMapsHistory,
      variables: { 
        event_type:et,
        major_jurisdiction:majj,
        minor_jurisdiction:minj,
        local_division:String(props.ld), 
        year:String(props.year), 
        lng:props.lng, 
        lat:props.lat 
      }
  });

  // const { loading2, error2, data2 } = useQuery(GET_NEARBY_FEDERAL_POLL_MAPS_HISTORY, {onCompleted: setNearbyPollMapsHistory,
  //   variables: { year:String(props.year), lng:props.lng, lat:props.lat }
  // });

  useEffect(
    () => {
        if (nearbyPollMapsSameYear !== null) {
        }
    }, [nearbyPollMapsSameYear]);

  const setNear = (result) => {
    window.scrollTo(0, 0)
    dispatch({type: SET_VIEW_ADJUST, viewadjust: true})
    dispatch({type: SET_POLL_MAP, pollMap: result})
    dispatch({type: SET_MAP_SELECTED, mapSelected: result})
    dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
    dispatch({type: SET_POLL_MAP_YEAR, pollMapYear: result.year})
    dispatch({type: SET_FEDERAL_POLL_MAP, yearDivision: result.year+result.local_division})
    dispatch({type: SET_POLL_MAP_LOCAL_DIVISION, pollMapLocalDivision: result.local_division})
    dispatch({type: SET_MAP_COUNT, mapCount: mapCount+1})
    dispatch({type: SET_ASIDE_SHOW, asideShow: false})
    //history.push('/political/canada/federal/election/'+result.year+'/'+result.local_division);
    
  }

  function compare( a, b ) {
    if ( a.year < b.year ){
      return 1;
    }
    if ( a.year > b.year ){
      return -1;
    }
    return 0;
  }  

  return (
      <CRow>
            
                <CCol xs="12" sm="12" md="12">
            { nearbyPollMapsSameYear !== null ?
                <h3>Nearby ridings during this election</h3>
            : <></>}
                </CCol>
            
            
            { nearbyPollMapsSameYear !== null ? nearbyPollMapsSameYear.getPollMapsNearYear.map((r, i) => i<6 ? (
                <CCol key={i} xs="12" sm="6" md="4">
                <CLink style={{textDecoration:'none'}} key={i+1000} to={r.event_type === 'Federal' ? '/political/canada/federal/election/'+r.year+'/'+r.local_division : '/political/canada/'+r.event_type.toLowerCase()+'/election/'+provinceShortToLong(r.minor_jurisdiction).toLowerCase()+'/'+r.year+'/'+r.local_division} onClick={() => setNear(r)} >
                    <CCard>
                        <CCardHeader>
                            <CBadge className="mr-1 float-left" color={
                                r.hasOwnProperty('winner') ? 
                                r.winner === 'Conservative' ? "primary" : 
                                r.winner === "Liberal" ? "danger" : 
                                r.winner === "Ontario Liberal Party" ? "danger" : 
                                r.winner === "NDP" ? "warning" : 
                                r.winner === "Bloc Québécois" ? "info" : 
                                r.winner === "Canadian Alliance" ? "darkgreen" : 
                                r.winner === "Green Party" ? "success" : 
                                r.winner === "Green Party of Ontario" ? "success" : 
                                r.winner === "Ontario Green Party" ? "success" : 
                                r.winner === "Progressive Conservative" ? "lightblue" : 
                                "secondary" : 
                                "secondary"
                                }>{r.year}
                            </CBadge> 
                            {r.district}                                
                        </CCardHeader>
                        <CCardBody> { r.event_type === 'Provincial' ? 
                            <CImg style={{width:'100%'}} src={'https://geojson-maps.s3.amazonaws.com/images/'+r.minor_jurisdiction+'-'+r.year+'-'+r.local_division+'-600.png'} />
                            : 
                            <CImg style={{width:'100%'}} src={'https://geojson-maps.s3.amazonaws.com/images/'+r.year+'-'+r.local_division+'-600.png'} /> }
                        </CCardBody>
                    </CCard>
                </CLink>
                </CCol> ) : (<Fragment key={i}></Fragment>)
                ) : <></> }
            </CRow>
  )
}

export default NearbyMaps;
